import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Typography } from "@mui/material";
import PropTypes from 'prop-types';
import SaveIcon from '@mui/icons-material/Save';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { GridToolbarContainer, GridActionsCellItem, } from '@mui/x-data-grid';
import { randomId } from '@mui/x-data-grid-generator';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import { useTheme } from "@mui/material";
import useAxiosPrivate from "../../hooks/useAxiosPrivate"
import saveAppAccounts from "../../components/managers/saveAppAccounts"
import ConfirmDialog from '../../components/ConfirmDialog';
import { useNavigate, useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import handleError from "../../hooks/handleError";


function EditToolbar(props) {
    const { setAppAccts, setDisplayedAccounts } = props;

    const handleClick = () => {
        const id = randomId();
        const newRow = { id, name: '', actions: "INSERT" };
        setAppAccts((oldRows) => [...oldRows, newRow])
        setDisplayedAccounts((oldRows) => [...oldRows, newRow]);
    };

    return (
        <GridToolbarContainer>
            <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
                ADD RECORD
            </Button>
        </GridToolbarContainer>
    );
}





EditToolbar.propTypes = {
    setDisplayedAccounts: PropTypes.func.isRequired,
};






const Accounts = () => {

    useEffect(() => {
        document.title = 'Accounts | Fretless Finance';
    }, []);

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();
    const location = useLocation();
    var [AppAccounts, setAppAccts] = useState([]);
    var [DisplayedAccounts, setDisplayedAccounts] = useState([]);
    var [open, setOpen] = useState(false);
    var [deleteId, setDeleteId] = useState(0);
    const effectRan = useRef(false);
    var isMounted = false;
    const controller = new AbortController();



    useEffect(() => {
        if (effectRan.current === false) {

            let isMounted = true;
            const controller = new AbortController();

            const getAppAccounts = async () => {
                try {
                    var AppAcctsResponse = await axiosPrivate.get('/Settings/get/app-accounts', {
                        signal: controller.signal
                    });
                    console.log(AppAcctsResponse)
                    isMounted && setAppAccts(AppAcctsResponse.data);
                    setDisplayedAccounts(AppAcctsResponse.data);

                } catch (err) {
                    if ((err.response?.status === 401) || (err.response?.status === 403)) {
                        navigate('/sign-in', { state: { from: location }, replace: true });
                    }
                    else {
                        handleError(err);
                    }
                }
            }

            getAppAccounts();
            effectRan.current = true;
        }
        return () => {
            isMounted = false;
            controller.abort();

        }


    }, [])


    const processRowUpdate = (newRow) => {
        const updatedRow = { ...newRow, actions: ((newRow.actions !== "INSERT" & newRow.actions !== "DELETE") ? "UPDATE" : newRow.actions) };
        setAppAccts(AppAccounts.map((row) => (row.id === updatedRow.id ? updatedRow : row)));
        setDisplayedAccounts(DisplayedAccounts.map((row) => ((row.id === updatedRow.id & updatedRow.actions !== "DELETE") ? updatedRow : row)));
        return updatedRow;
    };

    const deleteAccount = () => {
        const deletedRow = AppAccounts.filter((row) => row.id === deleteId)[0]
        deletedRow.actions = "DELETE"

        processRowUpdate(deletedRow)
        setDisplayedAccounts(DisplayedAccounts.filter((row) => row.id !== deleteId));
    };

    const saveChangesHandler = event => {
        var updatedArray = AppAccounts.filter((row) => row.actions !== "DELETE")
        updatedArray = updatedArray.map(row => ({ ...row, actions: null }));

        saveAppAccounts(AppAccounts);
        setAppAccts(updatedArray)
    }

    const columns = [
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            width: 100,
            cellClassName: 'actions',
            getActions: ({ id }) => {
                return [
                    <GridActionsCellItem
                        icon={<DeleteIcon />}
                        label="Delete"
                        onClick={() => {
                            setDeleteId(id);
                            setOpen(true);
                        }}
                        color="inherit"
                    />,
                ];
            },
        },
        {
            field: "name",
            headerName: "Name",
            width: 150,
            type: "string",
            headerAlign: "center",
            align: "center",
            editable: true,
        },
        {
            field: "is_primary",
            headerName: "Primary",
            width: 100,
            type: "boolean",
            headerAlign: "center",
            align: "center",
            editable: true,
        },
        {
            field: "subscription_description_identifiers",
            headerName: "Subscription Description Identifiers",
            width: 800,
            type: "string",
            headerAlign: "center",
            align: "left",
            editable: true,
        },
        {
            field: "hsa_eligible_vendors",
            headerName: "HSA Eligible Vendors",
            width: 800,
            type: "string",
            headerAlign: "center",
            align: "left",
            editable: true,
        },
        {
            field: "income_sources",
            headerName: "Income Sources",
            width: 800,
            type: "string",
            headerAlign: "center",
            align: "left",
            editable: true,
        },
        {
            field: "income_sources_identifiers",
            headerName: "Income Sources Identifiers",
            width: 800,
            type: "string",
            headerAlign: "center",
            align: "left",
            editable: true,
        },
    ];

    return (
        <Box m="20px">
            <Header
                title="ACCOUNTS"
                titleSize="h2"
                subtitle="List of Accounts Whether It Be Personal Or Business"
                subtitleSize="h5"
            />
            < ToastContainer />
            <Box
                m="40px 0 0 0"
                height="67vh"
                sx={{
                    "& .MuiDataGrid-root": {
                        border: "none",
                    },
                    "& .MuiDataGrid-cell": {
                        borderBottom: "none",
                    },
                    "& .name-column--cell": {
                        color: colors.greenAccent[300],
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[400],
                        borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                        borderTop: "none",
                        backgroundColor: colors.blueAccent[400],
                    },
                    "& .MuiCheckbox-root": {
                        color: `${colors.greenAccent[200]} !important`,
                    },
                    "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                        color: `${colors.grey[100]} !important`,
                    },
                }}
            >
                <DataGrid
                    rows={DisplayedAccounts}
                    columns={columns}
                    CanUserAddRows="True"
                    CanUserDeleteRows="True"
                    processRowUpdate={processRowUpdate}
                    components={{ Toolbar: EditToolbar }}
                    componentsProps={{
                        toolbar: { AppAccounts, setAppAccts, setDisplayedAccounts }
                    }}
                    experimentalFeatures={{ newEditingApi: true }}
                    options={{ customToolbar: () => { } }}
                />
                <ConfirmDialog
                    title="Delete Account"
                    message="Are you sure you want to delete this?"
                    confirmBtnText="DELETE"
                    open={open}
                    setOpen={setOpen}
                    onConfirm={deleteAccount}>
                </ConfirmDialog>
            </Box>
            <Box padding="1rem" align="right">
                <Button onClick={saveChangesHandler}
                    sx={{
                        backgroundColor: colors.greenAccent[500],
                        color: "#ffffff",
                        '&:hover': {
                            backgroundColor: colors.greenAccent[300],
                            color: "#ffffff",
                        },
                        fontSize: "14px",
                        fontWeight: "bold",
                        padding: "10px 20px",
                    }}
                >
                    <SaveIcon sx={{ mr: "10px" }} />
                    Save Changes
                </Button>
            </Box>

        </Box>
    );
};

export default Accounts;